import React, { useEffect, useState } from 'react'
import {
	RadioButton,
	TextInput,
	Flexgrid,
	FlexgridItem,
} from '@wf-wfria/pioneer-core'
import { RICOH } from '../businessSegmentBrandIds'

export function ForgotUserIdRicohContractNumber({
	formatMessage,
	customerNumberRicohForgotUserId,
	contractNumberRicohForgotUserId,
	invoiceNumberRicohForgotUserId,
	onUpdateInput,
	onTextInputValidator,
	mode,
	contractOrInvoice,
	focusedElement,
	onSelectContractOrInvoice,
}) {
	const [key, setKey] = useState(Date.now())
	useEffect(() => {
		if (
			focusedElement !== 'email' &&
			focusedElement !== 'customerNumberRicohForgotUserId' &&
			focusedElement !== 'contractNumberRicohForgotUserId' &&
			focusedElement !== 'invoiceNumberRicohForgotUserId'
		) {
			const newKey = Date.now()
			setKey(newKey)
		}
	}, [focusedElement, setKey])

	if (mode !== RICOH) {
		return null
	}
	const contractOrInvoiceInputDisabled = !contractOrInvoice

	function onChange({ id, value }) {
		onUpdateInput(id, value)
	}

	function getCustomerOrContract(contractOrInvoice) {
		if (contractOrInvoice === 'invoiceRicoh') {
			return 'invoiceNumberRicohForgotUserId'
		}
		return 'contractNumberRicohForgotUserId'
	}

	function invokeOnSelectContractOrInvoice({ value }) {
		onSelectContractOrInvoice(value)
	}

	return (
		<Flexgrid columnGap={2} rowGap={2}>
			<FlexgridItem span={8}>
				<TextInput
					aria-label={formatMessage({
						id: 'wca-form.new-user-registration.customer-number.label',
					})}
					label={formatMessage({
						id: 'wca-form.new-user-registration.customer-number.label',
					})}
					aria-required={true}
					required={true}
					id="customerNumberRicohForgotUserId"
					name="customerNumberRicohForgotUserId"
					type="text"
					value={customerNumberRicohForgotUserId.value}
					onValueChange={onChange}
					customValidators={[
						(value) =>
							onTextInputValidator('customerNumberRicohForgotUserId', value),
					]}
					nativeValidationMessages={{
						valueMissing: formatMessage({
							id: 'required-field.empty.error.label',
						}),
					}}
				/>
			</FlexgridItem>
			<FlexgridItem span={8}>
				<RadioButton
					name="contractOrInvoice"
					label={formatMessage({
						id: 'wca-form.new-user-registration.radio.contract-number.label',
					})}
					role="radio"
					id={'contractRicohRadio'}
					value={'contractRicoh'}
					onValueChange={invokeOnSelectContractOrInvoice}
					checked={contractOrInvoice === 'contractRicoh'}
				/>
			</FlexgridItem>
			<FlexgridItem span={8}>
				<RadioButton
					name="contractOrInvoice"
					label={formatMessage({
						id: 'wca-form.new-user-registration.radio.invoice-number.label',
					})}
					role="radio"
					id={'invoiceRicohRadio'}
					value={'invoiceRicoh'}
					onValueChange={invokeOnSelectContractOrInvoice}
					checked={contractOrInvoice === 'invoiceRicoh'}
				/>
			</FlexgridItem>
			<FlexgridItem span={8}>
				{contractOrInvoice === 'contractRicoh' && (
					<TextInput
						key={key}
						aria-label={formatMessage({
							id: 'wca-form.new-user-registration.contract-number.label',
						})}
						label={formatMessage({
							id: 'wca-form.new-user-registration.contract-number.label',
						})}
						labelHidden={true}
						aria-required={true}
						required={true}
						disabled={contractOrInvoiceInputDisabled}
						id={'contractNumberRicohForgotUserId'}
						name={'contractNumberRicohForgotUserId'}
						type="text"
						value={contractNumberRicohForgotUserId.value}
						onValueChange={onChange}
						customValidators={[
							(value) =>
								onTextInputValidator(
									getCustomerOrContract('contractRicoh'),
									value,
								),
						]}
						nativeValidationMessages={{
							valueMissing: formatMessage({
								id: 'required-field.empty.error.label',
							}),
						}}
					/>
				)}
			</FlexgridItem>
			<FlexgridItem span={8}>
				{contractOrInvoice !== 'contractRicoh' && (
					<TextInput
						key={key}
						aria-label={formatMessage({
							id: 'wca-form.new-user-registration.invoice-number.label',
						})}
						label={formatMessage({
							id: 'wca-form.new-user-registration.invoice-number.label',
						})}
						labelHidden={true}
						aria-required={true}
						required={true}
						disabled={contractOrInvoiceInputDisabled}
						id={'invoiceNumberRicohForgotUserId'}
						name={'invoiceNumberRicohForgotUserId'}
						type="text"
						value={invoiceNumberRicohForgotUserId.value}
						onValueChange={onChange}
						customValidators={[
							(value) =>
								onTextInputValidator(
									getCustomerOrContract('invoiceRicoh'),
									value,
								),
						]}
						nativeValidationMessages={{
							valueMissing: formatMessage({
								id: 'required-field.empty.error.label',
							}),
						}}
					/>
				)}
			</FlexgridItem>
		</Flexgrid>
	)
}
